import { render, staticRenderFns } from "./SpeakerPreviewCard.vue?vue&type=template&id=21666b5c&scoped=true&"
import script from "./SpeakerPreviewCard.vue?vue&type=script&lang=js&"
export * from "./SpeakerPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./SpeakerPreviewCard.vue?vue&type=style&index=0&id=21666b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21666b5c",
  null
  
)

export default component.exports